import { render, staticRenderFns } from "./VideoFeeds.vue?vue&type=template&id=d3e1a0c0&scoped=true"
import script from "./VideoFeeds.vue?vue&type=script&lang=ts"
export * from "./VideoFeeds.vue?vue&type=script&lang=ts"
import style0 from "./VideoFeeds.vue?vue&type=style&index=0&id=d3e1a0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@7.22.10_css-loader@5.2.7_webpack@5.97.1__lodash@4.17.21_prettier@2.8.8_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e1a0c0",
  null
  
)

export default component.exports